module.exports = __webpack_public_path__ + "static/media/Packky.837b456a.svg";